module.exports = __webpack_public_path__ + "static/media/BBA-logo-white.e3c4d436.png";